"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetermineIfNewRoundCanBeStartedReplay = exports.DetermineIfNewRoundCanBeStartedNoBalanceCheck = exports.DetermineIfNewRoundCanBeStarted = void 0;
var _ = require("../../..");
var DetermineIfNewRoundCanBeStarted = exports.DetermineIfNewRoundCanBeStarted = function DetermineIfNewRoundCanBeStarted(state) {
  if (state.game.locked) return false;
  if (state.blitz.on || !state.game.gameReady) return false;
  if (state.game.roundState === _.RoundState.Started) return false;
  if (!state.config.promoGame && !state.promotion.on && state.balance.balance && state.bet.centValue > state.balance.balance.centValue) return false;
  if (state.ui.dialogState != _.DialogState.CLOSED) return false;
  return true;
};

/**
 * Almost the same as DetermineIfNewRoundCanBeStarted but does not check if blitz is on,
 * should instead turn of blitz mode first.
 * @param state 
 * @returns 
 */
var DetermineIfNewRoundCanBeStartedReplay = exports.DetermineIfNewRoundCanBeStartedReplay = function DetermineIfNewRoundCanBeStartedReplay(state) {
  if (!state.game.gameReady) return false;
  if (state.game.roundState === _.RoundState.Started) return false;
  if (!state.promotion.on && state.balance.balance && state.bet.centValue > state.balance.balance.centValue) return false;
  if (state.ui.dialogState != _.DialogState.CLOSED) return false;
  return true;
};
var DetermineIfNewRoundCanBeStartedNoBalanceCheck = exports.DetermineIfNewRoundCanBeStartedNoBalanceCheck = function DetermineIfNewRoundCanBeStartedNoBalanceCheck(state) {
  if (state.game.locked) return false;
  if (state.blitz.on || !state.game.gameReady) return false;
  if (state.game.roundState === _.RoundState.Started) return false;
  if (state.ui.dialogState != _.DialogState.CLOSED) return false;
  return true;
};
//# sourceMappingURL=DetermineIfNewRoundCanBestarted.js.map